<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import Department from './DepartmentSection'
import Position from './PositionSection'
import Recruitment from './RecruitmentSection'
import Unit from './UnitSection'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Department,
    Position,
    Recruitment,
    Unit,
  },
  data() {
    return {
      departmentKey: 1,
      unitKey: 100,
    }
  },
  computed: {
    title() {
      return this.$t('setting.list.employeeSetting.settingEmployee')
    },
    subTitle() {
      return this.$t('setting.list.employeeSetting.textEmployee')
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.employeeSetting.settingEmployee'),
        },
      ]
    },
  },
  mounted() {
    this.$store.commit('setting/SET_STATUS', 'Department')
  },
  methods: {
    refreshComponentDepartment() {
      this.departmentKey += 1
    },
    refreshComponentUnit() {
      this.departmentKey += 1
      this.unitKey += 1
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <form>
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted" nav-wrapper-class="mc-tab">
          <Department
            v-if="
              hasAccessAll([
                'company_structure:read',
                'company_structure:create',
                'company_structure:update',
                'company_structure:delete',
                'c2a-default-setkaryawan:read',
              ])
            "
            ref="department"
            :key="departmentKey"
            status="Department"
          />
          <Unit
            v-if="
              hasAccessAll([
                'company_structure:read',
                'company_structure:create',
                'company_structure:update',
                'company_structure:delete',
                'c2a-default-setkaryawan:read',
              ])
            "
            ref="empUnit"
            :key="unitKey"
            status="Unit"
            @refresh-component-dept="refreshComponentDepartment"
          />
          <Position
            v-if="
              hasAccessAll([
                'company_structure:read',
                'company_structure:create',
                'company_structure:update',
                'company_structure:delete',
                'c2a-default-setkaryawan:read',
              ])
            "
            ref="empPos"
            status="Position"
            @refresh-component-unit="refreshComponentUnit"
          />
          <Recruitment
            v-if="
              hasAccessAll([
                'employee_recruited_at:read',
                'employee_recruited_at:create',
                'employee_recruited_at:update',
                'employee_recruited_at:delete',
                'c2a-default-setkaryawan:read',
              ])
            "
            ref="empRecruitment"
            status="Recruitment"
          />
        </b-tabs>
      </b-card>
    </form>
  </Layout>
</template>
